import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ClientLogger } from 'bernie-client';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { HotelMapModel, PropertyLocationViewModel } from 'models';

import { UitkCard, UitkCardContent } from 'uitk-react-cards';

import { LocationHeader } from 'components/infosite/property-details/property-location/internals/location-header';
import { LocationStreetAddress } from 'components/infosite/property-details/property-location/internals/location-street-address';
import { WhatsAroundMap } from 'components/infosite/whats-around/whats-around-map';

export interface PropertyLocationProps {
  currentHotel?: CurrentHotelStore;
  mapModel?: HotelMapModel;
}

@inject('currentHotel')
@observer
export class PropertyLocation extends React.Component<PropertyLocationProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    const { currentHotel, mapModel } = this.props;
    const propertyLocationInfo =
      currentHotel.hotel && currentHotel.hotel.locationInfo && currentHotel.hotel.locationInfo.hotelDetailedLocation;

    if (!propertyLocationInfo) {
      return null;
    }

    return (
      <div className="uitk-grid" data-stid="hotel-detailed-location">
        <UitkCard>
          <UitkCardContent>
            <div
              className="uitk-cell s-cell-1-1 l-cell-1-3 xl-cell-1-3
              l-y-padding-three xl-y-padding-three l-x-padding-three xl-x-padding-three"
            >
              <LocationHeader title={propertyLocationInfo.title} />
            </div>
            <div
              className="uitk-cell s-cell-1-1 l-cell-2-3 xl-cell-2-3
              l-y-padding-three xl-y-padding-three l-x-padding-three xl-x-padding-three"
            >
              <Map mapModel={mapModel} propertyLocationInfo={propertyLocationInfo} />
            </div>
          </UitkCardContent>
        </UitkCard>
      </div>
    );
  }
}

interface MapProps extends PropertyLocationProps {
  propertyLocationInfo: PropertyLocationViewModel;
}

const Map: React.FunctionComponent<MapProps> = ({ mapModel, propertyLocationInfo }) => {
  const mapImageUrl = propertyLocationInfo.mapImageUrl;
  const logger = ClientLogger.getLoggerWithIdentifier('pwa.component.property-location');
  if (mapImageUrl && logger && typeof logger.logEvent === 'function') {
    logger.logEvent(new SystemEvent(SystemEventLevel.INFO, 'SDUI_HOTEL_DETAILED_LOCATION_MAP_LOADED'));
  }

  return (
    <>
      {mapImageUrl && (
        <div data-stid="property-location-map" className="all-x-margin-three all-y-margin-three">
          <WhatsAroundMap src={mapImageUrl} rfrr=":HotelDetailedLocationMap.Open" mapModel={mapModel} />
        </div>
      )}
      {propertyLocationInfo.streetAddress && <LocationStreetAddress propertyLocationInfo={propertyLocationInfo} />}
      <p className="uitk-card-separator-bottom" />
    </>
  );
};
